// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2Kbae","cardTitle":"Card_cardTitle__1a-9_","cardImg":"Card_cardImg__1gB2S","displayInFirstPosition":"Card_displayInFirstPosition__14LSd"};